import { fetchSingleTarget, saveTarget } from '@/api'
import { TARGET_TYPE, TARGET_TYPES_INTEGERS, DATASOURCES } from '@/appLogic/targets/Constants'

class WorkbenchInterface {
  /**
   * This should pass the interface to the current store, so that the other store
   * can communicate with this interface
   * @param {*} context - this is the VueX context object
   */
  setInterface(context) {
    throw Error('Not Implemented')
  }

  getTargetAndDatasourceInformation(query) {
    const DATASET_TO_TARGET = {
      amrld: TARGET_TYPE.LAS,
      mri: TARGET_TYPE.LAS,
      ncs: TARGET_TYPE.LAS,
      xandr: TARGET_TYPE.XANDR_SEGMENT,
      adstra: TARGET_TYPE.ADSTRA,
      prism: TARGET_TYPE.PRISM,
      dnb: TARGET_TYPE.DNB,
      max: TARGET_TYPE.MAX,
      byod: TARGET_TYPE.BYOD,
      tve: TARGET_TYPE.TVE,
      epsilon: TARGET_TYPE.EPSILON,
      'd+': TARGET_TYPE.DISCOVERY_PLUS,
      dcr: TARGET_TYPE.DCR,
    }
    const DATASET_TO_DATASOURCE = {
      mri: DATASOURCES.MRI,
      amrld: DATASOURCES.AMRLD,
      ncs: DATASOURCES.NCS,
      xandr: DATASOURCES.XANDR,
      adstra: DATASOURCES.ADSTRA,
      prism: DATASOURCES.PRISM,
      dnb: DATASOURCES.DNB,
      max: DATASOURCES.MAX,
      byod: DATASOURCES.BYOD,
      tve: DATASOURCES.TVE,
      epsilon: DATASOURCES.EPSILON,
      'd+': DATASOURCES.DISCOVERY_PLUS,
      dcr: DATASOURCES.DCR,
    }
    const DATASET_TO_TARGET_TYPE = {
      mri: TARGET_TYPES_INTEGERS.LAS,
      amrld: TARGET_TYPES_INTEGERS.LAS,
      ncs: TARGET_TYPES_INTEGERS.LAS,
      xandr: TARGET_TYPES_INTEGERS.ADSTRA,
      adstra: TARGET_TYPES_INTEGERS.ADSTRA,
      prism: TARGET_TYPES_INTEGERS.PRISM,
      dnb: TARGET_TYPES_INTEGERS.DNB,
      max: TARGET_TYPES_INTEGERS.MAX,
      byod: TARGET_TYPES_INTEGERS.BYOD,
      tve: TARGET_TYPES_INTEGERS.TVE,
      epsilon: TARGET_TYPES_INTEGERS.EPSILON,
      'd+': TARGET_TYPES_INTEGERS.DISCOVERY_PLUS,
      dcr: TARGET_TYPES_INTEGERS.DCR,
    }
    // datasets with restrictions on compatibility or destination types
    const R_DATASETS = ['mri', 'ncs', 'dnb', 'max', 'byod', 'tve']

    const getAllDatasetsRootFamilyFromQuery = function (query) {
      const dataSetsRootFamilies = new Set()
      for (let el of query) {
        if (Array.isArray(el)) {
          let dtsFamily = getAllDatasetsRootFamilyFromQuery(el)
          for (let df of dtsFamily) {
            dataSetsRootFamilies.add(df)
          }
        } else if (typeof el === 'string') {
          // ignore
        } else {
          // it is an object
          dataSetsRootFamilies.add(el.rootFamily)
        }
      }
      return Array.from(dataSetsRootFamilies)
    }

    let datasetFamilies = getAllDatasetsRootFamilyFromQuery(query)
    if (datasetFamilies.length >= 1) {
      // give preference to restricted datasets for setting the target type
      let df = datasetFamilies.find(ds => R_DATASETS.includes(ds)) || datasetFamilies[0]
      return {
        target: DATASET_TO_TARGET[df],
        target_datasource: DATASET_TO_DATASOURCE[df],
        target_type: DATASET_TO_TARGET_TYPE[df],
      }
    } else {
      throw Error("Couldn't find target datasource from the definition")
    }
  }

  getTarget(targetInfo) {
    return fetchSingleTarget({ target_id: targetInfo.id }).then(resp => resp.data)
  }

  saveTarget(targetInfo) {
    throw Error('Not Implemented')
  }

  onTargetDefinitionChange(targetDefinition) {
    throw Error('Not Implemented')
  }

  getTargetDefinition(getters) {
    throw Error('Not Implemented')
  }

  submitDownstream() {
    throw Error('Not Implemented')
  }

  queryForData() {
    throw Error('Not Implemented')
  }

  sendDownStream() {
    throw Error('Not Implemented')
  }

  onSetTarget() {
    throw Error('Not Implemented')
  }

  reset(context) {
    throw Error('Not Implemented')
  }

  /**
   * @returns [{name, module}, ......]
   */
  getStoreModules() {
    return []
  }

  getDefaultTarget(targetInfo) {
    return {}
  }

  /**
   * When there is a duplicate on create
   */
  onDuplicate() {
    throw Error('Not Implemented')
  }

  /**
   * When the view is created
   */
  onCreate() {
    throw Error('Not Implemented')
  }

  model() {
    throw Error('Not Implemented')
  }

  onSetAdvertiser() {
    throw Error('onSetAdvertiser not Implemented')
  }
}

export default WorkbenchInterface



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/common/WorkbenchInterface.js